export default "<div class=\"admin-wrapper\">\n  <router-outlet></router-outlet>\n</div>\n"